import React from 'react'

import * as S from './step-indicator.styled'

interface StepIndicatorProps {
  totalSteps: number
  currentStep: number
}

export const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps) => {
  return (
    <S.StepIndicator>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1
        const isActive = stepNumber === currentStep
        const isCompleted = stepNumber < currentStep

        return (
          <React.Fragment key={stepNumber}>
            <S.Step $isActive={isActive} $isCompleted={isCompleted} />
            {stepNumber < totalSteps && <S.Line $isActive={isActive} $isCompleted={isCompleted} />}
          </React.Fragment>
        )
      })}
    </S.StepIndicator>
  )
}
